import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_API_URL?.replace('/api', '') || 'http://localhost:8888';

let socket = null;

export const getSocket = () => {
	return socket;
};

export const initializeSocket = (token) => {
	if (socket) {
		return socket;
	}

	socket = io(SOCKET_URL, {
		auth: {
			token
		},
		autoConnect: true,
		reconnection: true,
		reconnectionDelay: 1000,
		reconnectionAttempts: 5
	});

	socket.on('connect', () => {
		console.log('Socket connected:', socket.id);
	});

	socket.on('disconnect', (reason) => {
		console.log('Socket disconnected:', reason);
	});

	socket.on('connect_error', (error) => {
		console.error('Socket connection error:', error);
	});

	return socket;
};

export const disconnectSocket = () => {
	if (socket) {
		socket.disconnect();
		socket = null;
	}
};

export const joinConversation = (conversationId) => {
	if (socket) {
		socket.emit('conversation:join', conversationId);
	}
};

export const leaveConversation = (conversationId) => {
	if (socket) {
		socket.emit('conversation:leave', conversationId);
	}
};

export const sendTypingStart = (conversationId) => {
	if (socket) {
		socket.emit('typing:start', { conversationId });
	}
};

export const sendTypingStop = (conversationId) => {
	if (socket) {
		socket.emit('typing:stop', { conversationId });
	}
};

export const sendMessage = (conversationId, content, type = 'text') => {
	if (socket) {
		socket.emit('message:send', { conversationId, content, type });
	}
};

export const markMessageAsRead = (conversationId) => {
	if (socket) {
		socket.emit('message:read', { conversationId });
	}
};
